type Memberships = { category: string; additional_categories?: readonly string[] };

// Copy defaults without aliasing the API record or the editor's dirty baseline.
export function initialProductCategories(product?: Memberships | null) {
  return { category: product?.category ?? '', additional_categories: [...(product?.additional_categories ?? [])] };
}

// Do not infer memberships from a SKU, or depend on a taxonomy fetch to retain
// existing selections. New secondary options are constrained by the editor UI.
export function sanitiseAdditionalCategories(primary: string, categories: readonly string[] = []) {
  return [...new Set(categories.map(value => value.trim()).filter(value => value && value !== primary.trim()))];
}

export function productCategoryMemberships(product: Memberships) {
  return [product.category.trim(), ...sanitiseAdditionalCategories(product.category, product.additional_categories)].filter(Boolean);
}
